import React, { useState } from "react";
import { Stückliste } from "../Stückliste";
import { setDialogQueue } from "oc-ui/dialogs/Dialogs";
import { I18N } from "oc-I18N";

export function Price({
  onlyBestellliste = false,
  highlightElements = true,
}: {
  onlyBestellliste?: boolean;
  highlightElements?: boolean;
}) {
  const [, update] = useState({});
  const setShowStückliste = (on: boolean) => {
    APP.arrangement.showStückliste = on;
    APP.logUserAction({ action: "showStücklisteButton", on }, { stateChange: false });
    update({});
    if (on) {
      setDialogQueue([]);
      APP.arrangement.setSelectedObjects([]);
    }
    APP.dirty();
  };
  return (
    <React.Fragment>
      <div>
        <button
          className="price-button button outlined-button large font-size-large"
          data-button-key={I18N("Stückliste anzeigen")}
          title={I18N("Stückliste anzeigen")}
          aria-label={
            I18N("aria::Stückliste anzeigen mit Gesamtpreis") +
            ": " +
            I18N.formatCurrency(APP.arrangement.gesamtpreis)
          }
          onClick={() => setShowStückliste(!APP.arrangement.showStückliste)}
        >
          <div className="container">
            <div className="mobile-view">
              <div className="icon icon-list-ul-solid font-size-large" aria-hidden="true"></div>
            </div>

            <div className="desktop-view">
              {!APP.isTorkonfigurator && (
                <div className="icon icon-list-ul-solid font-size-large" aria-hidden="true"></div>
              )}
              <span className="font-size-large">
                {I18N("Stückliste")}
                <span className="gesamtpreis">
                  : {I18N.formatCurrency(APP.arrangement.gesamtpreis)}
                </span>
              </span>
            </div>
          </div>
        </button>
      </div>
      {APP.arrangement.showStückliste && (
        <Stückliste
          hideStückListe={() => setShowStückliste(false)}
          onlyBestellliste={onlyBestellliste}
          highlightElements={highlightElements}
        />
      )}
    </React.Fragment>
  );
}
